// frontend/src/pages/LoginPage.js
import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AuthLayout from '../components/auth/AuthLayout';
import '../components/auth/AuthLayout.css';
import { FiLogIn} from 'react-icons/fi';



const LoginPage = () => {
    const [email, setEmail] =useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login, isAuthenticated, isAdmin } = useAuth(); // Pega isAdmin do contexto
    const navigate = useNavigate();

    // Se o usuário já está logado, redireciona para o dashboard
    if (isAuthenticated && isAdmin) {
        return <Navigate to="/" />;
    }
    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await login(email, password);
            navigate('/'); // Redireciona após o login
        } catch (err) {
            const errorMessage = err.response?.data?.message || 'Erro ao tentar fazer login.';
            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthLayout title="Painel Administrador">
            <form onSubmit={handleLogin}>
                {error && <p className="auth-error-message">{error}</p>}
                <div className="auth-form-group">
                    <label className="auth-label" htmlFor="email">Email</label>
                    <input
                        className="auth-input"
                        type="email" id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div className="auth-form-group">
                    <label className="auth-label" htmlFor="password">Senha</label>
                    <input
                        className="auth-input"
                        type="password" id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" className="auth-button primary-button" disabled={loading}>
                    <FiLogIn/> {loading ? 'Entrando...' : 'Entrar'}
                </button>
            </form>
        </AuthLayout>
    );
};

export default LoginPage;